import { Alert, Box, Grid, Typography } from "@mui/material"

import { DlspTable } from "./DlspTable"
import { safeFormatDate } from "@northpowerdev/np-react-utils"
    

export function RemedialDetails({remedial, fspStatusNoEdit, remedialBy, remedialDate}) {

    const leftTableRows = []
    leftTableRows.push({label: 'Work Type',                    text:  remedial?.workers                       })
    leftTableRows.push({label: 'Planned Outage',               text:  remedial?.remedialPlannedOutage         })
    leftTableRows.push({label: 'Traffic Management',           text:  remedial?.remedialTrafficManagement     })
    leftTableRows.push({label: 'Customer Notification',        text:  remedial?.remedialCustomerNotification  })
    
    

    const rightTableRows = []
    rightTableRows.push({label: 'Wasp Update',                  text:  remedial?.remedialWaspUpdate           })
    rightTableRows.push({label: 'Asset Agreement',             text:  remedial?.remedialAssetAgreement        })
    rightTableRows.push({label: 'Work Instruction',            text:  remedial?.remedialWorkInstructions      })
    rightTableRows.push({label: 'Salesforce Case Number',      text:  remedial?.caseNumber                    })
    
    

    const styling = {m:'-60px', ml:'-270px',mr:3 , width:'100%',transform: "rotate(45deg)", textAlign:'right'}
    return (
        <Box sx={{my: 2}}>
            <Grid item xs={12}>
                    <Typography variant="body2"><strong>{remedialBy}</strong></Typography>
                    <Typography variant="body2"><strong>{safeFormatDate(remedialDate, 'd MMMM yyyy HH:mm a')}</strong></Typography>

                </Grid>
            {
            ( remedial)
            &&
            <Grid container spacing={2} backgroundColor={fspStatusNoEdit?'rgba(0, 0, 0, 0.05)':''} >
                {
                    fspStatusNoEdit 
                    && 
                    <>
                        <Alert severity="info" sx={{m:1, ml:2, width:'100%'}}>
                            This has been successfully sent to Salesforce and is now in read-only mode. Editing is not possible.
                        </Alert>
                        <Typography variant="h1" color={'rgba(0, 0, 0, 0.1)'} sx={styling}>Read only</Typography>
                     </>
                }
                <Grid item md={6}>
                    <DlspTable rows={leftTableRows} skipHeader={true} />
                </Grid>
                <Grid item md={6}>
                    <DlspTable rows={rightTableRows} skipHeader={true} />
                </Grid>
            </Grid>
            }
        </Box>
    )
}